<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15iuq7L/tc-custom/9781614238959.jpg?1705026024133" alt="This image is the cover for the book Riding Denver's Rails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Riding Denver's Rails
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1872, the Mile High City embraced a new way to get around and eventually boasted one of the largest streetcar systems in the nation. Enjoy the varied stops the transit system made as it grew along with the city, from the early horsecars of the Denver Horse Railroad Company and the steam-powered Colfax Avenue Railway to the running cable cars of the Denver Tramway and the electric trolleys of the South Denver Cable Railway Company. Though the last of the city's streetcars were pulled from service in the 1950s, Denver continues to expand its modern public transportation system with today's growing Light Rail. Join Denver historian Kevin Pharris on a tour of the city's glorious transit past as well as the modern improvements that are getting people onto the rails once again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Pharris, Kenton Forrest
      </h2>
      
      <p class="authorDescription body article">After moving around with his military family, Keven Pharris found Colorado the best place to be and has settled down to pursue the work of growing Denver History Tours, with many joys (most of the tours) and many woes (the ghost parts). It has been a great life so far, and it is his fervent hope that when he goes, he won't end up joining the ghosts he has inadvertently associated with during his time as a guide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?609e2b40